export const summaryRows: string[] = [
  "Volume 01 — Fondamenti dell'Industria del Petrolio e del Gas",
  'Volume 02 — Geologia del Petrolio, Giacimenti ed Esplorazione',
  'Volume 03 — Perforazione, Costruzione dei Pozzi e Produzione',
  'Volume 04 — Trasporto, Stoccaggio, Raffinazione e Prodotti Petroliferi',
  'Volume 05 — Sicurezza, Ambiente, Economia e Transizione Energetica',
  "Volume 06 — Insegnare l'Industria del Petrolio e del Gas",
  'Bonus 1 — 150 Attività e Sfide su Petrolio e Gas per la Classe',
  'Bonus 2 — Banca di Verifiche e Valutazioni su Petrolio e Gas',
  "Bonus 3 — 100 Casi di Studio e Scenari dell'Industria del Petrolio e del Gas",
  'Bonus 4 — Dizionario del Docente di Petrolio e Gas: 200 Concetti Essenziali',
  'Bonus 5 — Guida del Docente: Strategie Didattiche, Metodi di Discussione e Programmazione',
  'Garanzia di soddisfazione di 7 giorni',
  'Accesso immediato',
];
